import React from "react";

const ImportantDates = () => {
  return (
    <div className="bg-orange-600 pt-48 text-white pb-20 ">
      <div className="font-bold text-2xl mb-8 ml-20">IMPORTANT DATES</div>

      <div>
        <table className="md:ml-20 mx-4 text-xl">
          <tr>
            <td className="border-b-2 border-t-2 py-2">
              <div className="px-2 py-2 border-r-2">
                4<sup>th</sup> October 2023
              </div>
            </td>
            <td className="border-b-2 border-t-2 px-8 py-4">
              Abstract Submission Opens
            </td>
          </tr>
          <tr>
            <td className="border-b-2 py-2">
              <div className="px-2 py-2 border-r-2">
                31<sup>st</sup> January 2024
              </div>
            </td>
            <td className="border-b-2 px-8 py-4">
              Abstract Submission Deadline
            </td>
          </tr>
          <tr>
            <td className="border-b-2 py-2">
              <div className="px-2 py-2 border-r-2">
                5<sup>th</sup> February to 10<sup>th</sup> March 2024
              </div>
            </td>
            <td className="border-b-2 px-8 py-4">
              Abstract Acceptance Notification
            </td>
          </tr>
          <tr>
            <td className="border-b-2 py-2">
              <div className="px-2 py-2 border-r-2">
                10<sup>th</sup> February to 15<sup>th</sup> June 2024
              </div>
            </td>
            <td className="border-b-2 px-8 py-4">
              Submission of full length paper
            </td>
          </tr>
          <tr>
            <td className="border-b-2 py-2">
              <div className="px-2 py-2 border-r-2">
                15<sup>th</sup> June to 5<sup>th</sup> July 2024
              </div>
            </td>
            <td className="border-b-2 px-8 py-4">
              Acceptance of full length paper
            </td>
          </tr>
          <tr>
            <td className="border-b-2 py-2">
              <div className="px-2 py-2 border-r-2">
                6<sup>th</sup> July to 15<sup>th</sup> July 2024
              </div>
            </td>
            <td className="border-b-2 px-8 py-4">
              Submission of revised full length paper after review (if required)
            </td>
          </tr>
          <tr>
            <td className="border-b-2 py-2">
              <div className="px-2 py-2 border-r-2">
                16<sup>th</sup> July to 25<sup>th</sup> July 2024
              </div>
            </td>
            <td className="border-b-2 px-8 py-4">
              Final Acceptance of full length camera ready paper
            </td>
          </tr>
        </table>
      </div>
    </div>
  );
};
export default ImportantDates;
